import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, LogIn } from 'lucide-react';
import { Link } from 'react-router-dom';
import { nav } from '../../mock/data';
import { HouseLogo } from './Decor';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? 'bg-white/85 backdrop-blur-md shadow-[0_6px_24px_rgba(80,140,180,0.12)]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 lg:px-10 py-3">
        <a href="#top" className="flex items-center gap-3 group">
          <div className="transition-transform duration-500 group-hover:rotate-[-6deg]">
            <HouseLogo size={scrolled ? 42 : 54} />
          </div>
          <div className="leading-tight">
            <div className="font-hand text-[13px] text-[#5a8f3d] tracking-widest">TAMAN KANAK-KANAK</div>
            <div className="font-brush text-[22px] text-[#3a2a1a]">MELATI ASRI</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {nav.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              className="relative font-hand text-[17px] text-[#3a2a1a] hover:text-[#c74a2a] transition-colors"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-[3px] w-0 bg-[#ee7a3d] rounded-full transition-all duration-300 group-hover:w-full hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button
            onClick={() => scrollTo('berita')}
            className="px-4 py-2 rounded-full bg-[#2a2a2a] text-white text-sm font-hand hover:bg-[#3a3a3a] transition-colors"
          >
            Info Sekolah
          </button>
          <Link
            to="/login"
            className="px-4 py-2 rounded-full border-2 border-[#3aa9b7] text-[#2b8b98] font-hand text-[15px] hover:bg-[#3aa9b7] hover:text-white transition-colors"
          >
            <span className="inline-flex items-center gap-2"><LogIn size={15}/> Admin</span>
          </Link>
          <button
            onClick={() => scrollTo('kontak')}
            className="relative px-6 py-3 rounded-full bg-[#3aa9b7] text-white font-hand text-[16px] shadow-[0_5px_0_#256d78] hover:translate-y-[2px] hover:shadow-[0_3px_0_#256d78] transition-all"
          >
            <span className="inline-flex items-center gap-2"><Phone size={16} /> Hubungi Kami</span>
          </button>
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen((o) => !o)} aria-label="menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-white border-t border-[#e8dcc4] px-6 py-5 shadow-lg">
          <div className="flex flex-col gap-4">
            {nav.map((n) => (
              <button
                key={n.id}
                onClick={() => scrollTo(n.id)}
                className="font-hand text-lg text-left text-[#3a2a1a]"
              >
                {n.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo('kontak')}
              className="mt-2 px-6 py-3 rounded-full bg-[#3aa9b7] text-white font-hand text-[16px]"
            >
              Hubungi Kami
            </button>
            <Link to="/login" className="px-6 py-3 rounded-full border-2 border-[#3aa9b7] text-[#2b8b98] font-hand text-center">Login Admin</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
